import { IconProps } from "../../../types/style";

const LocationOutline = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99994 7.21473C6.86151 7.21473 7.55994 6.51629 7.55994 5.65473C7.55994 4.79316 6.86151 4.09473 5.99994 4.09473C5.13838 4.09473 4.43994 4.79316 4.43994 5.65473C4.43994 6.51629 5.13838 7.21473 5.99994 7.21473Z"
          stroke={color}
        />
        <path
          d="M1.8101 4.745C2.7951 0.415001 9.2101 0.420001 10.1901 4.75C10.7651 7.29 9.1851 9.44 7.8001 10.77C6.7951 11.74 5.2051 11.74 4.1951 10.77C2.8151 9.44 1.2351 7.285 1.8101 4.745Z"
          stroke={color}
        />
      </svg>
    </div>
  );
};

export default LocationOutline;
